import formValidationConfig from '@/javascript/new_site/modules/formValidationConfig.js'
const phoneMask = (el) => {
  let SPMaskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11
    ? '(00) 00000-0000'
    : '(00) 0000-00009'
  },
  spOptions = {
    onKeyPress: function (val, e, field, options) {
      field.mask(SPMaskBehavior.apply({}, arguments), options)
    },
  }

  $(el).mask(SPMaskBehavior, spOptions)
}
// const cnpjCpfMask = (el) => {
//    let options =  {
//      onKeyPress: function(value, e, field, options) {
//        let mask = (value.length < 15) ? '000.000.000-009' : '00.000.000/0000-00';
//        $(el).mask(mask, options);
//    }};
//
//   $(el).mask('000.000.000-009', options);
// }

const signUp = () => {
  $(document).ready(() => {
    $('form').validate({
      ...formValidationConfig.default,
      messages: {
        'user[first_name]': {
          required: 'Preecha seu nome',
        },
        'user[last_name]': {
          required: 'Preencha seu sobrenome',
        },
        'user[cell_phone]': {
          required: 'Preencha seu celular',
          minlength: 'Digite corretamente seu celular',
        },
        'user[email]': {
          required: 'Digite seu e-mail',
          email: 'E-mail inválido',
        },
        'user[password]': {
          required: 'Senha obrigatória',
          minlength: 'A senha precisa ter no mínimo 6 caracteres',
        },
        'user[password_confirmation]': {
          required: 'Confirmação de senha é obrigatório',
          equalTo: 'Os campos devem ser iguais',
        },

        terms: {
          required: "Leia e aceite os termos"
        },
      },
      rules: {
        "user[cell_phone]": {
          required: true,
          minlength: 6
        },
        "user[password]": {
          required: true,
          minlength: 6
        },
        "user[password_confirmation]": {
          equalTo: '#user_password',
        },
      },
    })

    phoneMask("#user_cell_phone");
    // cnpjCpfMask('#user_cpf_cnpj');
  });
}

export default () => {
  $(document).ready(() => {
    setTimeout(()=>{
      $('#next-phase').click((e) => {
        e.preventDefault();
        if ($('form').validate().form()) {
          $('#phase-1').toggleClass('hide');
          $('#phase-2').toggleClass('hide');
        }
      });
      $('#previous-phase').click((e) => {
        e.preventDefault();
        $('#phase-1').toggleClass('hide');
        $('#phase-2').toggleClass('hide');
      });
      signUp();
    },300)
  });
}
